import React from 'react'

function PanelHeader( { label, children } ) {
	return (
		<div className="stlst-components-panel__header">
			{ label && <h2>{ label }</h2> }
			{ children }
		</div>
	);
}

export default PanelHeader;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/panel/header.js